export default {
  currentEvent: state => state.current
}
